<script setup>
import { computed, ref } from 'vue';

import IconSearch from '@/components/Icons/Search.vue';

const props = defineProps({
    type: {
        required: false,
        type: String,
        default: 'post',
    },
    defaultValue: {
        required: false,
        type: String,
        default: '',
    },
});

const routeTo = computed(() => {
    return {
        name: `search.${props.type}`,
        query: {
            query: '',
        }
    }
});
</script>

<template>
    <button
        aria-label="Activate search form"
        class="flex items-center justify-center"
        type="button"
        @click="$router.push(routeTo)">
        <IconSearch class="size-8" />
    </button>
</template>
